export class NoteQueryParameters {
  functionalAreaId?: string;
  id?: string;
  page?: number;
  pageSize?: number;
  sourceReference1Id?: string;
  sourceReference2Id?: string;
  sequence?: number;

  constructor(obj?: NoteQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
